import BaseSection from '@/sections/base'

const selectors = {
  autogrow: '[data-autogrow]'
}

export default class MainContactSection extends BaseSection {
  static TYPE = 'main-contact'

  textarea: HTMLTextAreaElement | undefined

  constructor(container: HTMLElement) {
    super(container)

    this.textarea = this.qs(selectors.autogrow) as HTMLTextAreaElement | undefined

    if (this.textarea) {
      this.grow = this.grow.bind(this)
      // Listener lives on an element inside the section — garbage collected when the DOM is removed
      this.textarea.addEventListener('input', this.grow)
      this.grow()
    }
  }

  // Fixed min-height in CSS; this lets it grow with the content but never shrink below that
  grow() {
    if (!this.textarea) return
    this.textarea.style.height = 'auto'
    this.textarea.style.height = `${this.textarea.scrollHeight}px`
  }
}
